module.exports = __webpack_public_path__ + "img/mongodb.7063eb8e.png";